import { Injectable } from '@angular/core';
import { checkIfColumnMatches } from '../preferences/preferences-service/check-if-column-matches';
import { TColumn } from '../site/site-table/columns/column.model';
import { EDefaultColumnWidths } from '../site/site-table/columns/default-column-widths-enum';

@Injectable({
  providedIn: 'root',
})
export class CompareColumnsWithSavedViewService {
  constructor() {}

  compareColumns(
    savedViewColumns: TColumn[],
    tableColumns: TColumn[],
    workspaceId: string,
  ): boolean {
    let match = true;

    for (let i = 0; i < tableColumns.length; i++) {
      const column = tableColumns[i];
      let viewColumn: TColumn | undefined;

      if (column.customFieldIds) {
        viewColumn = savedViewColumns.find((savedViewColumn) =>
          savedViewColumn.customFieldIds?.some((id) => column.customFieldIds.includes(id)),
        );
      }
      if (!viewColumn) {
        viewColumn = savedViewColumns.find(
          (savedViewColumn) => savedViewColumn.name === column.name,
        );
      }

      if (!viewColumn) {
        // Check if column is default
        match =
          column.width === EDefaultColumnWidths.CUSTOM_FIELD &&
          !column.hidden &&
          !column.groupIndex &&
          !column.sortIndex &&
          !column.groupOrder &&
          !column.sortOrder;
      } else {
        match = checkIfColumnMatches(viewColumn, column, workspaceId);
      }

      if (!match) {
        return false;
      }
    }

    return match;
  }
}
